module.exports = __webpack_public_path__ + "img/suolangunicom.38f86eae.jpg";